const colors = {
	neutral: {
		"low-300": "#D6D5EB",
		"low-400": "#666666",
		"low-pure-500": "#29292F",
		"high-pure-50": "#FFFFFF",
		"high-100": "#F0F0F0",
		"high-200": "#D6D5EB"
	},
	"feedback-positive": {
		"low-950": "#1A2F2A",
		"pure-500": "#00D4A1",
		"high-50": "#E5FBF6"
	},
	"feedback-alert": {
		"low-950": "#322E21",
		"pure-500": "#D6D300",
		"high-50": "#FFFEE5",
		soft: "#FFFEE5",
		alerts: "#D6D300"
	},
	"feedback-negative": {
		"low-950": "#331F21",
		"pure-500": "#F83446",
		"high-50": "#FCEEF2"
	},
	"feedback-focus": {
		"low-950": "#272732",
		"pure-500": "#8887F3",
		"high-50": "#F3F3FE"
	},
	"branding-highway": {
		"low-950": "#231D2E",
		"low-900": "#2A1D3F",
		"low-800": "#371C62",
		"low-700": "#441C85",
		"low-600": "#511CA7",
		"pure-500": "#5E22F3",
		"high-400": "#7E49D5",
		"high-300": "#9E77DF",
		"high-200": "#BFA4EA",
		"high-100": "#DFD2F4",
		"high-50": "#EFE8FA"
	},
	title: {
		default: "#5E22F3",
		secondary: "#29292F"
	},
	paragraph: {
		default: "#D6D5EB",
		soft: "#4F5266"
	},
	background: {
		soft: "#F5F5FF"
	},
	stroke: {
		default: "#D6D5EB"
	},
	"button-primary": {
		default: "#5E22F3",
		hover: "#EFE9FF",
		disabled: "#8484A2",
		"text-hover": "#29292F"
	},
	transparent: "transparent"
};

module.exports = colors;
